export default {"src":"/_next/static/media/DryEyeSyndrome.cc8f63dc.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};